class FaqSection extends HTMLElement {
  constructor() {
    super()

    this.categoryButtons = this.querySelectorAll('[data-faq-category-button]');
    this.categories = this.querySelectorAll('[data-faq-category]');

    this.categoryButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault()
        const buttonTextHandleized = button.innerText.toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-')
        this.toggleActiveCategoryButton(button)
        this.toggleCategoryDisplay(buttonTextHandleized)
      })
    });

  }

  connectedCallback() {
    if (!this.dataset.faqPage) return;
    
    this.urlParam = window.location.href.substring(window.location.href.indexOf("#") + 1);

    const link = this.querySelector(`[data-faq-link="${this.urlParam}"]`);
    if (link) {
      const activeLink = this.querySelector(`[data-faq-link]:not([data-faq-link="${this.urlParam}"]) .active`);
      if (activeLink) activeLink.classList.remove('active');
      link.querySelector('a').classList.add('active');
    }

    const content = this.querySelector(`[data-faq-content="${this.urlParam}"]`);
    if (content) {
      const activeContent = this.querySelector(`[data-faq-content]:not([data-faq-content="${this.urlParam}"]):not(.hide)`);
      if (activeContent) activeContent.classList.add('hide');
      content.classList.remove('hide');
    }
  }

  toggleActiveCategoryButton(button) {
    if (button.classList.contains('active')) {
      return
    }

    this.categoryButtons.forEach((button) => {
      button.classList.remove('active')
    })

    button.classList.toggle('active')
  }

  toggleCategoryDisplay(title) {
    const categoryToUpdate = this.querySelector(`.category--${title}`)

    if (!categoryToUpdate.classList.contains('hide')) {
      return
    }

    this.categories.forEach((category) => {
      category.classList.add('hide')
    })

    categoryToUpdate.classList.toggle('hide')
  }
}

customElements.define('faq-section', FaqSection);